import React from "react";
import { useLanguage } from "@/context/LanguageContext";

export function StatusBadge({ status }) {
  const { t } = useLanguage();
  const map = {
    planned: { cls: "badge-planned", label: t.status_planned },
    ongoing: { cls: "badge-ongoing", label: t.status_ongoing },
    completed: { cls: "badge-completed", label: t.status_completed },
    preparing: { cls: "badge-preparing", label: t.status_preparing },
  };
  const s = map[status] || map.planned;
  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${s.cls}`} data-testid={`status-badge-${status}`}>
      {s.label}
    </span>
  );
}

export function PageHero({ title, description, image, overline, testid = "page-hero" }) {
  return (
    <section className="relative overflow-hidden bg-white pt-16 md:pt-24 pb-16 hero-grid-bg" data-testid={testid}>
      <div className="useko-container relative z-10">
        <div className="max-w-3xl">
          {overline && <div className="overline mb-4">{overline}</div>}
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-[#102A43] tracking-tight leading-[1.05]" data-testid="page-hero-title">
            {title}
          </h1>
          {description && (
            <p className="mt-6 text-base sm:text-lg text-[#4B5563] leading-relaxed max-w-2xl">
              {description}
            </p>
          )}
          {image && (
            <div className="mt-8 lg:hidden aspect-[16/9] rounded-2xl overflow-hidden border border-[#E5E7EB] shadow-sm">
              <img src={image} alt="" className="w-full h-full object-cover"/>
            </div>
          )}
        </div>
      </div>
      {image && (
        <div className="absolute -bottom-16 -end-20 w-96 h-96 rounded-full overflow-hidden opacity-30 pointer-events-none hidden lg:block">
          <img src={image} alt="" className="w-full h-full object-cover" />
        </div>
      )}
    </section>
  );
}

export function SectionTitle({ overline, title, description, center = false, testid }) {
  return (
    <div className={`${center ? "text-center mx-auto" : ""} max-w-3xl mb-12`} data-testid={testid}>
      {overline && <div className="overline mb-3">{overline}</div>}
      <h2 className="font-heading text-3xl sm:text-4xl font-bold text-[#102A43] tracking-tight leading-tight">{title}</h2>
      {description && <p className="mt-4 text-base text-[#4B5563] leading-relaxed">{description}</p>}
    </div>
  );
}

export function Spinner({ size = 20 }) {
  return (
    <div
      className="inline-block animate-spin rounded-full border-2 border-[#E5E7EB] border-t-[#1F8A5B]"
      style={{ width: size, height: size }}
    />
  );
}
